import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import ChatInterface from '../components/ChatInterface';

export default function ProjectChatPage() {
  const { id } = useParams();

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ChatInterface projectId={id} />
    </Box>
  );
}
